var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1668 6.66667C14.6271 6.66667 15.0002 7.03977 15.0002 7.50001V15.8333C15.0002 17.2141 13.8809 18.3333 12.5002 18.3333H7.50016C6.11945 18.3333 5.00016 17.2141 5.00016 15.8333V7.50001C5.00016 7.03977 5.37326 6.66667 5.8335 6.66667H14.1668ZM13.3335 8.33334H6.66683V15.8333C6.66683 16.2936 7.03993 16.6667 7.50016 16.6667H12.5002C12.9604 16.6667 13.3335 16.2936 13.3335 15.8333V8.33334ZM7.50016 2.50001C7.50016 2.03977 7.87326 1.66667 8.3335 1.66667H11.6668C12.1271 1.66667 12.5002 2.03977 12.5002 2.50001V3.33334H15.8335C16.2937 3.33334 16.6668 3.70643 16.6668 4.16667C16.6668 4.62691 16.2937 5.00001 15.8335 5.00001H4.16683C3.70659 5.00001 3.3335 4.62691 3.3335 4.16667C3.3335 3.70643 3.70659 3.33334 4.16683 3.33334H7.50016V2.50001Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a4420a39df1df1a4853f53da554263e2.svg";
export { ForwardRef as ReactComponent };